module.exports = __webpack_public_path__ + "img/eightday1-1.94f6b3d7.jpg";